<template>
    <section class="teamDetails">
		<Nav title="团队详情" />
        <section class="card_list">
            <div class="card">
                <div class="item">
                    <div class="label"><p>团队名称</p></div>
                    <div class="info"><p>{{team.teamName}}</p></div>
                </div>
            </div>
            <div class="card">
                <div class="item">
                    <div class="label"><p>团队管理员</p></div>
                    <div class="info"><p>{{team.teamAdminName || '未设置'}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>自动接单开关</p></div>
                    <div class="info flex">
                        <p v-if="team.autoAcceptSwitch === 0">开启中</p>
                        <p v-if="team.autoAcceptSwitch === 1">已关闭</p>
                        <van-switch v-if="team.autoAcceptSwitch != -1" v-model="form.autoAcceptSwitch" active-color="#055CE8" inactive-color="#CED7E2" size=20 @change='onAutoAcceptSwitch' />
                    </div>
                </div>
                <div class="item">
                    <div class="label"><p>团队启停状态</p></div>
                    <div class="info flex">
                        <p v-if="team.status === 0">启用中</p>
                        <p v-if="team.status === 1">已停用</p>
                        <van-switch v-if="team.status != -1" v-model="form.status" active-color="#055CE8" inactive-color="#CED7E2" size=20 @change='onTeamStatusSwitch' />
                    </div>
                </div>
                <div class="item">
                    <div class="label"><p>客户池分配规则</p></div>
                    <div class="info flex">
                        <p v-if="team.customerPoolRule === 0">自动分配</p>
                        <p v-if="team.customerPoolRule === 1">手动分配</p>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="item">
                    <div class="label"><p>创建时间</p></div>
                    <div class="info"><p>{{team.gmtCreate}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>更新时间</p></div>
                    <div class="info"><p>{{team.gmtModify}}</p></div>
                </div>
            </div>                   
        </section>
        <section>
            <div class="button_area">
                <van-button round block type="primary" to="/team" native-type="submit">返回</van-button>                
            </div>
        </section>
	</section>
</template>

<script>
import Nav from "components/Nav"
import { Toast } from 'vant';

import teamServer from "api/team";

export default {
    name: "teamDetails",
	components: {
		Nav,
	},
    data() {
        return {
            id: 0,
            team: {
                autoAcceptSwitch: -1,
                status: -1,
            },
            form: {},
		};
    },
    created() {
        this.id = this.$route.params.id
        this.getInfo();
	},
	mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},	
    methods: {
        getInfo() {
            teamServer.getTeamDetails({id: this.id}).then((res) => {
                this.team = res.data

                this.form.autoAcceptSwitch = !this.team.autoAcceptSwitch
                this.form.status = !this.team.status
            })
        },

        onAutoAcceptSwitch() {
            teamServer.switchTeamAutoAccept({id: this.id}).then((res) => {
                this.getInfo()
            })
        },

        onTeamStatusSwitch() {
            teamServer.switchTeamStatus({id: this.id}).then((res) => {
                this.getInfo()
            })
        },        
    },
};
</script>

<style lang="scss">
	.teamDetails {
		padding-top: 46px;
		padding-bottom: 100px;

        .card {
            margin-bottom: 22px;
            background-color: #FDFDFD;
            border-radius: 24px;

            .item {
                margin-left: 30px;
                padding: 20px 30px 20px 0;
                border-bottom: 1px solid #E9F0F8;
                display: flex;
                justify-content: space-between;

                .label p {
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 400;
                    color: #4D5B80;
                }

                .info p {
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 400;
                    color: #000;
                }

                .info.flex {
                    display: flex;
                    align-items: center;

                    p {
                        margin-right: 4px;
                    }
                }
            }

            .item:last-child {
                border-bottom: 0;
            }
        }

        .button_area {
            margin: 30px;
        }
	}
</style>


// WEBPACK FOOTER //
// src/views/team/TeamDetails.vue